export default "__VITE_ASSET__FGVXgZGt__"